import { FunnelSuggestion, ColorOption, VehicleStatusOption } from '../types'

export const COLOR_OPTIONS: ColorOption[] = [
 { value: '#3B82F6', label: 'Azul' },
 { value: '#EAB308', label: 'Amarelo' },
 { value: '#8B5CF6', label: 'Roxo' },
 { value: '#10B981', label: 'Verde' },
 { value: '#EF4444', label: 'Vermelho' },
 { value: '#F59E0B', label: 'Laranja' },
 { value: '#EC4899', label: 'Rosa' },
 { value: '#6366F1', label: 'Índigo' },
 { value: '#14B8A6', label: 'Turquesa' },
 { value: '#6B7280', label: 'Cinza' },
]

export const VEHICLE_STATUS_OPTIONS: VehicleStatusOption[] = [
 { value: null, label: 'Nenhum (não altera)', icon: 'X' },
 { value: 'in_stock', label: 'Em Estoque', icon: 'Package' },
 { value: 'reserved', label: 'Reservado', icon: 'Clock' },
 { value: 'sold', label: 'Vendido', icon: 'CheckCircle' },
 { value: 'in_transit', label: 'Em Trânsito', icon: 'Truck' }
]

export const FUNNEL_SUGGESTIONS: FunnelSuggestion[] = [
 {
 title: 'Funil de Vendas Tradicional',
 description: 'Organização clássica para maximizar conversão',
 statuses: [
 { label: 'Novo', value: 'new', color: '#3B82F6', description: 'Leads que acabaram de entrar', vehicleStatus: null, locked: true },
 { label: 'Qualificação', value: 'qualification', color: '#EAB308', description: 'Validando interesse e perfil', vehicleStatus: null },
 { label: 'Apresentação', value: 'presentation', color: '#F59E0B', description: 'Apresentando veículos e soluções', vehicleStatus: 'reserved' },
 { label: 'Proposta', value: 'proposal', color: '#8B5CF6', description: 'Enviando proposta comercial', vehicleStatus: 'reserved' },
 { label: 'Negociação', value: 'negotiating', color: '#EC4899', description: 'Ajustando valores e condições', vehicleStatus: 'reserved' },
 { label: 'Fechado', value: 'closed', color: '#10B981', description: 'Venda concretizada', vehicleStatus: 'sold', locked: true },
 { label: 'Perdido', value: 'lost', color: '#EF4444', description: 'Lead não converteu', vehicleStatus: 'in_stock', locked: true }
 ]
 },
 {
 title: 'Funil Simplificado',
 description: 'Ideal para equipes pequenas ou processos ágeis',
 statuses: [
 { label: 'Novo', value: 'new', color: '#3B82F6', description: 'Leads novos', vehicleStatus: null, locked: true },
 { label: 'Em Contato', value: 'contacted', color: '#EAB308', description: 'Primeiro contato realizado', vehicleStatus: 'reserved' },
 { label: 'Negociação', value: 'negotiating', color: '#8B5CF6', description: 'Em processo de negociação', vehicleStatus: 'reserved' },
 { label: 'Fechado', value: 'closed', color: '#10B981', description: 'Venda fechada', vehicleStatus: 'sold', locked: true },
 { label: 'Perdido', value: 'lost', color: '#EF4444', description: 'Não converteu', vehicleStatus: 'in_stock', locked: true }
 ]
 },
 {
 title: 'Funil Focado em Follow-up',
 description: 'Enfatiza o acompanhamento constante',
 statuses: [
 { label: 'Novo', value: 'new', color: '#3B82F6', description: 'Lead inicial', vehicleStatus: null, locked: true },
 { label: 'Primeiro Contato', value: 'first_contact', color: '#EAB308', description: 'Contato inicial feito', vehicleStatus: null },
 { label: 'Follow-up 1', value: 'followup_1', color: '#F59E0B', description: 'Primeira tentativa de retorno', vehicleStatus: 'reserved' },
 { label: 'Follow-up 2', value: 'followup_2', color: '#EC4899', description: 'Segunda tentativa de retorno', vehicleStatus: 'reserved' },
 { label: 'Negociação Final', value: 'final_negotiation', color: '#8B5CF6', description: 'Fechando negócio', vehicleStatus: 'reserved' },
 { label: 'Fechado', value: 'closed', color: '#10B981', description: 'Venda concretizada', vehicleStatus: 'sold', locked: true },
 { label: 'Perdido', value: 'lost', color: '#EF4444', description: 'Sem interesse', vehicleStatus: 'in_stock', locked: true }
 ]
 },
 {
 title: 'Funil por Temperatura',
 description: 'Organiza leads pela probabilidade de conversão',
 statuses: [
 { label: 'Novo', value: 'new', color: '#3B82F6', description: 'Recém chegado', vehicleStatus: null, locked: true },
 { label: 'Frio', value: 'cold', color: '#6B7280', description: 'Baixa probabilidade', vehicleStatus: null },
 { label: 'Morno', value: 'warm', color: '#EAB308', description: 'Mostrando interesse', vehicleStatus: null },
 { label: 'Quente', value: 'hot', color: '#F59E0B', description: 'Alto interesse', vehicleStatus: 'reserved' },
 { label: 'Muito Quente', value: 'very_hot', color: '#EC4899', description: 'Pronto para fechar', vehicleStatus: 'reserved' },
 { label: 'Fechado', value: 'closed', color: '#10B981', description: 'Venda fechada', vehicleStatus: 'sold', locked: true },
 { label: 'Perdido', value: 'lost', color: '#EF4444', description: 'Desistiu', vehicleStatus: 'in_stock', locked: true }
 ]
 }
]

